if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					this.dispatchEvent(new CustomEvent('cart-updated', { bubbles: true }));
					document.dispatchEvent(new CustomEvent('cart:updated'));

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {
  class CartProductQuantity extends HTMLElement {
    constructor(){
      super();

      const input = this.querySelector('.qty');
      if (!input) return;

      // Sørg for at +/− er knapper (ikke submit)
      this.querySelectorAll('.qty-plus, .qty-minus').forEach(btn => {
        if (btn.getAttribute('type') !== 'button') btn.setAttribute('type','button');
      });

      // Optional: limit fra data-limit
      const limitAttr = input.getAttribute('data-limit');
      const hasLimit  = limitAttr != null && limitAttr !== '';
      const limit     = hasLimit ? parseInt(limitAttr, 10) : null;

      // Når man skriver manuelt: clamp + opdater
      input.addEventListener('change', () => {
        let val = parseInt(input.value, 10);
        if (!Number.isFinite(val) || val < 0) val = 0;
        if (hasLimit && Number.isFinite(limit) && val > limit) val = limit;
        input.value = String(val);
        if (hasLimit && Number.isFinite(limit) && val >= limit) {
          const modal = document.querySelector('.country-quantity-limit--modal');
          if (modal) modal.classList.remove('hidden');
        }
        this.changeCartInput();
      });

      // Klik på +/−: ændr IKKE værdien selv — lad temaet gøre det.
      // Vi kalder blot update efter, så UI re-render korrekt.
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.qty-plus, .qty-minus');
        if (!btn) return;

        // ingen preventDefault/stopPropagation -> temaets handler kører
        const before = parseInt(input.value, 10) || 0;

        // efter næste frame læser vi temaets nye værdi og opdaterer kurven
        requestAnimationFrame(() => {
          let val = parseInt(input.value, 10);
          if (!Number.isFinite(val) || val < 0) val = 0;
          if (hasLimit && Number.isFinite(limit) && val > limit) val = limit; // clamp visning hvis tema gik over
          input.value = String(val);

          if (hasLimit && Number.isFinite(limit) && val >= limit && val !== before) {
            const modal = document.querySelector('.country-quantity-limit--modal');
            if (modal) modal.classList.remove('hidden');
          }

          // Kald temaets egen updater (samme som ved manuel input)
          this.changeCartInput();
        });
      });
    }

    changeCartInput(){
      setTimeout(() => {
        const cartForm = document.getElementById('AjaxCartForm');
        if (!cartForm) return;
        const item = this.closest('[data-js-cart-item]');
        const qty  = parseInt(this.querySelector('.qty').value, 10) || 0;
        cartForm.updateCartQty(item, qty);
      }, 50);
    }
  }

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}


// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

window.onload = (e) => {
  
  const checkoutButton = document.querySelector('#CheckOut');
  if (checkoutButton != null) {
    checkoutButton.addEventListener('click', (e) => {
      const t = e.target;
      const parentEl = t.parentElement;
      const ageConfirm = parentEl.querySelector('#ageConfirm');
      const errorMessage = parentEl.querySelector('#error-message');
      
      if (!ageConfirm.checked) {
        e.preventDefault();
        e.stopPropagation();
        
        errorMessage.style.display = 'block';
      } else {
        errorMessage.style.display = 'none';
      }
    });
  }
};

